import { render, staticRenderFns } from "./RegisterManagements.vue?vue&type=template&id=32be5c0a"
import script from "./RegisterManagements.vue?vue&type=script&lang=js"
export * from "./RegisterManagements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports